import { ReactNode } from 'react'

import styles from './ScrollContainer.module.css'

export type ScrollContainerProps = {
  children: ReactNode
  containerClassName?: string
  contentClassName?: string
}

export const ScrollContainer = ({
  children,
  containerClassName,
  contentClassName,
}: ScrollContainerProps) => {
  return (
    <div className={[styles.scrollContainer, containerClassName].join(' ')}>
      <div className={[styles.scrollContent, contentClassName].join(' ')}>{children}</div>
    </div>
  )
}
